export const sampleStadiums = [
  {
    id: 'footbolito-beirut',
    name: 'Footbolito Beirut',
    location: 'Achrafieh, Beirut',
    ownerEmail: 'owner@footbolito.com',
    ownerName: 'Ahmad Hassan',
    city: 'Beirut',
    area: 'Achrafieh',
    coordinates: { lat: 33.8938, lng: 35.5018 },
    phone: '+961 3 123 456',
    description: 'Premium sports complex with multiple fields and courts',
    amenities: ['Free Parking', 'Changing Rooms', 'Showers', 'Cafeteria', 'Night Lights'],
    photos: [
      'https://images.unsplash.com/photo-1529900748604-07564a03e7a6?w=1200',
      'https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=1200',
      'https://images.unsplash.com/photo-1551958219-acbc608c6377?w=1200'
    ],
    rating: 4.5,
    reviewCount: 24,
    featured: true,
    onlinePaymentRequired: true,
    sports: [
      {
        id: 'football-12',
        name: 'Football Field (12 players)',
        type: 'football',
        capacity: 12,
        pricePerSlot: 40,
        openTime: '08:00',
        closeTime: '23:00',
        duration: 90,
        size: '40x20m'
      },
      {
        id: 'football-10',
        name: 'Football Field (10 players)',
        type: 'football',
        capacity: 10,
        pricePerSlot: 35,
        openTime: '08:00',
        closeTime: '23:00',
        duration: 90,
        size: '35x18m'
      },
      {
        id: 'padel-1',
        name: 'Padel Court 1',
        type: 'padel',
        capacity: 4,
        pricePerSlot: 25,
        openTime: '08:00',
        closeTime: '23:00',
        duration: 60,
        size: 'Standard'
      }
    ]
  },
  {
    id: 'sportsville-beirut',
    name: 'Sportsville',
    location: 'Verdun, Beirut',
    ownerEmail: 'owner@sportsville.com',
    ownerName: 'Karim Mohamad',
    city: 'Beirut',
    area: 'Verdun',
    coordinates: { lat: 33.8886, lng: 35.4955 },
    phone: '+961 3 234 567',
    description: 'Modern sports facility with professional-grade courts',
    amenities: ['Indoor Courts', 'Air Conditioning', 'Lockers', 'Equipment Rental', 'Pro Shop'],
    photos: [
      'https://images.unsplash.com/photo-1519766304817-4f37bda74a26?w=1200',
      'https://images.unsplash.com/photo-1587280501635-68a0e82cd5ff?w=1200',
      'https://images.unsplash.com/photo-1546519638-68e109498ffc?w=1200'
    ],
    rating: 4.8,
    reviewCount: 42,
    featured: true,
    sports: [
      {
        id: 'football-8',
        name: 'Mini Football (8 players)',
        type: 'football',
        capacity: 8,
        pricePerSlot: 30,
        openTime: '08:00',
        closeTime: '23:00',
        duration: 60,
        size: '30x15m'
      },
      {
        id: 'basketball-1',
        name: 'Basketball Court',
        type: 'basketball',
        capacity: 10,
        pricePerSlot: 35,
        openTime: '08:00',
        closeTime: '23:00',
        duration: 60,
        size: 'Full Court'
      },
      {
        id: 'volleyball-1',
        name: 'Volleyball Court',
        type: 'volleyball',
        capacity: 12,
        pricePerSlot: 30,
        openTime: '08:00',
        closeTime: '23:00',
        duration: 60,
        size: 'Standard'
      }
    ]
  },
  {
    id: 'green-field-tripoli',
    name: 'Green Field Stadium',
    location: 'El Mina, Tripoli',
    ownerEmail: 'owner@greenfield.com',
    ownerName: 'Hassan Ali',
    city: 'Tripoli',
    area: 'El Mina',
    coordinates: { lat: 34.4415, lng: 35.8283 },
    phone: '+961 3 345 678',
    description: 'Spacious outdoor stadium with sea view',
    amenities: ['Sea View', 'Parking', 'Cafeteria', 'Changing Rooms'],
    photos: [
      'https://images.unsplash.com/photo-1529900748604-07564a03e7a6?w=1200',
      'https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=1200'
    ],
    rating: 4.3,
    reviewCount: 18,
    featured: false,
    sports: [
      {
        id: 'football-12',
        name: 'Main Football Field',
        type: 'football',
        capacity: 12,
        pricePerSlot: 35,
        openTime: '08:00',
        closeTime: '22:00',
        duration: 90,
        size: '40x20m'
      }
    ]
  },
  {
    id: 'arena-sports-jounieh',
    name: 'Arena Sports Complex',
    location: 'Jounieh',
    ownerEmail: 'owner@arena.com',
    ownerName: 'Fadi Khoury',
    city: 'Jounieh',
    area: 'Jounieh',
    coordinates: { lat: 33.9811, lng: 35.6178 },
    phone: '+961 3 456 789',
    description: 'Multi-sport complex in the heart of Jounieh',
    amenities: ['Mountain View', 'Free Parking', 'Restaurant', 'Kids Area'],
    photos: [
      'https://images.unsplash.com/photo-1551958219-acbc608c6377?w=1200',
      'https://images.unsplash.com/photo-1587280501635-68a0e82cd5ff?w=1200'
    ],
    rating: 4.6,
    reviewCount: 31,
    featured: true,
    sports: [
      {
        id: 'football-10',
        name: 'Football Field',
        type: 'football',
        capacity: 10,
        pricePerSlot: 38,
        openTime: '08:00',
        closeTime: '23:00',
        duration: 90,
        size: '35x18m'
      },
      {
        id: 'padel-1',
        name: 'Padel Court',
        type: 'padel',
        capacity: 4,
        pricePerSlot: 28,
        openTime: '08:00',
        closeTime: '23:00',
        duration: 60,
        size: 'Standard'
      },
      {
        id: 'tennis-1',
        name: 'Tennis Court',
        type: 'tennis',
        capacity: 4,
        pricePerSlot: 30,
        openTime: '08:00',
        closeTime: '23:00',
        duration: 60,
        size: 'Standard'
      }
    ]
  }
];

export const sportCategories = [
  {
    id: 'football',
    name: 'Football',
    nameAr: 'كرة القدم',
    icon: '⚽',
    color: 'green',
    description: 'Book football fields for 5v5, 6v6, or full matches',
    descriptionAr: 'احجز ملاعب كرة قدم 5 ضد 5، 6 ضد 6، أو مباريات كاملة'
  },
  {
    id: 'basketball',
    name: 'Basketball',
    nameAr: 'كرة السلة',
    icon: '🏀',
    color: 'orange',
    description: 'Indoor and outdoor basketball courts',
    descriptionAr: 'ملاعب كرة سلة داخلية وخارجية'
  },
  {
    id: 'padel',
    name: 'Padel',
    nameAr: 'بادل',
    icon: '🎾',
    color: 'blue',
    description: 'Padel courts for doubles matches',
    descriptionAr: 'ملاعب بادل لمباريات الزوجي'
  },
  {
    id: 'volleyball',
    name: 'Volleyball',
    nameAr: 'كرة الطائرة',
    icon: '🏐',
    color: 'purple',
    description: 'Beach and indoor volleyball courts',
    descriptionAr: 'ملاعب كرة طائرة شاطئية وداخلية'
  },
  {
    id: 'tennis',
    name: 'Tennis',
    nameAr: 'التنس',
    icon: '🎾',
    color: 'yellow',
    description: 'Professional tennis courts',
    descriptionAr: 'ملاعب تنس احترافية'
  }
];